import React, { useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import queryString from 'query-string';

import { useApi } from 'common/hooks/api';
import Loading from 'common/components/Loading';

import { useWhoAmI } from '../queries/useWhoAmI';
import { useAgencyPortalStatus } from '../queries/useAgencyPortalStatus';

const buildV2Target = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('cpv', '2');
  if (process.env.REACT_APP_CLIENT_V2_ORIGIN) {
    const v2 = new URL(process.env.REACT_APP_CLIENT_V2_ORIGIN);
    url.protocol = v2.protocol;
    url.host = v2.host;
  }
  return url.toString();
};

const TokenRedirectShim = ({ token, children }) => {
  const Api = useApi();

  useEffect(() => {
    Api._updateInstanceToken(token);
  }, [Api, token]);

  const { data } = useWhoAmI(token);
  const newPortal = data && data.agency && data.agency.newPortal === true;

  useEffect(() => {
    if (newPortal) {
      window.location.replace(buildV2Target());
    }
  }, [newPortal]);

  if (newPortal) return <Loading message="Loading..." />;
  return children;
};

const AgencyRedirectShim = ({ agencyId, children }) => {
  const { data } = useAgencyPortalStatus(agencyId);
  const newPortal = data && data.agency && data.agency.newPortal === true;

  useEffect(() => {
    if (newPortal) {
      window.location.replace(buildV2Target());
    }
  }, [newPortal]);

  if (newPortal) return <Loading message="Loading..." />;
  return children;
};

const ClientV2RedirectShim = ({ children }) => {
  const { token, cpv } = queryString.parse(window.location.search);
  if (cpv === '2') return children;

  if (token) {
    return <TokenRedirectShim token={token}>{children}</TokenRedirectShim>;
  }

  const match = matchPath(window.location.pathname, {
    path: '/client/example/:savedItineraryId/:agencyId/:agentId',
  });
  if (match && match.params && match.params.agencyId) {
    return <AgencyRedirectShim agencyId={match.params.agencyId}>{children}</AgencyRedirectShim>;
  }

  return children;
};

export default ClientV2RedirectShim;
